import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ThemePresetMutationKeys } from '../../../keys'
import type { ApplyThemePresetResponse } from '../../../type'
import { applyThemePreset } from '../../services'

interface UseMutationApplyThemePresetProps {
	presetId: string
}

export default function useMutationApplyThemePreset(
	props?: UseBaseMutationOptions<
		ApplyThemePresetResponse,
		UseMutationApplyThemePresetProps
	>,
) {
	return useMutation({
		mutationKey: [ThemePresetMutationKeys.ApplyThemePreset],
		mutationFn: (params) => applyThemePreset({ presetId: params.presetId }),
		...props,
	})
}
